import { render, staticRenderFns } from "./FrameBox.vue?vue&type=template&id=401a5414&"
import script from "./FrameBox.vue?vue&type=script&lang=ts&"
export * from "./FrameBox.vue?vue&type=script&lang=ts&"
import style0 from "./FrameBox.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FrameBox.vue"
export default component.exports